import React, { useState } from "react";
import CheckBoxGroup from "./CheckBoxGroup";
import './filter.css';

require("es6-promise").polyfill()
require("isomorphic-fetch")

export default function Filter({ keyword, city, category, min_spending, max_spending, setPOIs }) {
  const [stateCities, setStateCities] = useState(city);
  const [stateCategories, setStateCategories] = useState(category);
  const [priceMin, setPriceMin] = useState(min_spending);
  const [priceMax, setPriceMax] = useState(max_spending);

  return (
    <div>
      <div className="h4 mb-1 mt-4">Filter</div>
      {/* logo */}

      <div className="filter-container p-4 me-3">

        <div className="h4 filter-by">Lokasi</div>
        <CheckBoxGroup
          url={'https://liwat-id-backend.herokuapp.com/api/cities/'}
          state={stateCities} setState={setStateCities}
          post_attr={'id'} display_attr={'name'}
        />
        <hr/>

        <div className="h4 filter-by">Kategori</div>
        <CheckBoxGroup
          url={'https://liwat-id-backend.herokuapp.com/api/categories/'}
          state={stateCategories} setState={setStateCategories}
          post_attr={'id'} display_attr={'sub_category'} display_attr_2={'category'}
        />
        <hr/>

        <div className="h4 filter-by">Harga</div>
        <div className="h6"><b>Dari</b></div>
        <input type="text" className="form-control h6" placeholder="Masukkan harga berupa angka" alt="price-min" value={priceMin}
        onInput={(e) => setPriceMin(e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1'))} />
        <br/>
        <div className="h6"><b>Hingga</b></div>
        <input type="text" className="form-control h6" placeholder="Masukkan harga berupa angka" alt="price-max" value={priceMax}
        onInput={(e) => setPriceMax(e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1'))} />
        <br/>

        <div className="d-flex justify-content-center">
          <a href={`/info`+
            `?keyword=${keyword}`+
            `&city=${stateCities}`+
            `&category=${stateCategories}`+
            `&min_spending=${priceMin}`+
            `&max_spending=${priceMax}`}

            className="button button-terapkan"
            onClick={() => setPOIs([{id:-1, name:'loading'}])}>
              Terapkan
          </a>
        </div>
      </div>
    </div>
  );
}
